import { render, staticRenderFns } from "./BrandJoinRecordList.vue?vue&type=template&id=8bc88bfc"
import script from "./BrandJoinRecordList.vue?vue&type=script&lang=js"
export * from "./BrandJoinRecordList.vue?vue&type=script&lang=js"
import style0 from "./BrandJoinRecordList.vue?vue&type=style&index=0&id=8bc88bfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports